// Sugalarm — segmented control. Used by Alerts, Log, History (window pills).

import type { ReactNode } from "react";
import styles from "./Tabs.module.css";

export interface TabDef<Id extends string> {
  id: Id;
  label: ReactNode;
}

interface Props<Id extends string> {
  tabs: TabDef<Id>[];
  activeId: Id;
  onChange: (id: Id) => void;
  className?: string;
  /** Cycle 183: opt-in stronger active treatment — a SOLID filled accent
   *  segment (high-contrast `--bg-sunk` ink) instead of the default raised
   *  `--bg-elev` segment. DEFAULT OFF so the Dashboard / Alerts / Log
   *  Tabs are byte-identical; History's window pills opt in for parity
   *  with the Now chart's unmistakable active pill. */
  accentActive?: boolean;
}

export function Tabs<Id extends string>({
  tabs,
  activeId,
  onChange,
  className,
  accentActive = false,
}: Props<Id>) {
  return (
    <div className={`${styles.row} ${className ?? ""}`} role="tablist">
      {tabs.map((t) => {
        const active = t.id === activeId;
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={active}
            type="button"
            className={`${styles.tab} ${
              active ? styles.active : ""
            } ${active && accentActive ? styles.accentActive : ""}`}
            onClick={() => onChange(t.id)}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
